import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
const buttonStyleObject = {
  // Default (was hover earlier)
  backgroundColor: "rgba(74, 144, 226, 0.2)",
  border: "1px solid rgba(74, 144, 226, 0.3)",
  transform: "translateY(-2px)",
  boxShadow: "0 8px 25px rgba(74, 144, 226, 0.2)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  color: "#333",
  borderRadius: "12px",
  fontWeight: 600,
  transition: "all 0.3s ease",

  "&:hover": {
    // Reversed back to the plain frosted glass look
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    transform: "translateY(0)", // reset lift effect
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
  },
};
export const GlassButton = styled(Button)(() => buttonStyleObject);
export const GlassButtonLoading = styled(LoadingButton)(
  () => buttonStyleObject
);
